import React from 'react';
import { Checkbox, FormControlLabel, FormGroup, Stack, Typography } from '@mui/material';

export default function RecoveryJournalInstruction({ checked, onChange, sendCredentials, onCredentialsChange }) {
  return (
    <FormGroup sx={{ gap: 1.5 }}>
      <Typography variant="boxHeading" color="secondary">
        Recovery journal instruction
      </Typography>
      <Typography variant="body2" color="text.secondary">
        The invitation email includes the following instruction from your firm, whether or not you include login credentials.
      </Typography>
      <Stack gap={1.5} sx={{ p: 2, border: 1, borderColor: 'divider', borderRadius: 1 }}>
        <Typography variant="body2">
          Please use MyCaseCare to keep a recovery journal for your case. Record your pain and symptoms, appointments and treatment, expenses, relevant documents, and other case updates privately for our legal team.
        </Typography>
        <Typography variant="body2">
          Our firm requests these updates as confidential communications to help us provide you with legal advice and prepare your case. Please keep your journal and communications private, and ask your legal team before sharing them outside the firm.
        </Typography>
        <Typography variant="body2">
          These communications are intended to be protected by attorney-client privilege where applicable. Not every entry or uploaded document is automatically privileged.
        </Typography>
      </Stack>
      <FormControlLabel
        control={<Checkbox checked={checked} onChange={event => onChange(event.target.checked)} />}
        label="On behalf of our firm, I am instructing this client to keep this recovery journal for legal advice and case preparation."
      />
      {onCredentialsChange && (
        <FormControlLabel
          control={<Checkbox checked={sendCredentials} onChange={event => onCredentialsChange(event.target.checked)} />}
          label="Include mobile app login credentials in the invitation email (new accounts only)."
        />
      )}
      <Typography variant="body2" color="text.secondary">
        If this client already uses MyCaseCare independently, they must accept your invitation before your firm can access their records. Their earlier records remain identifiable as recorded before joining your firm.
      </Typography>
    </FormGroup>
  );
}
